export default __webpack_public_path__ + "static/melt-b2425265d95696ca121468f8f01613ee.png";